import React, { useEffect } from "react";
import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
import dayjs from "dayjs";
import { chartOptions, dateRanges, chartFields } from "../Data/data";
import { Typography } from "@mui/material";

const { RangePicker } = DatePicker;
const { Option } = Select;

const Orbdatetypefiledsselector = ({
  selectedDates,
  setSelectedDates,
  selectedChart,
  setSelectedChart,
  selectedParameters,
  setSelectedParameters,
  setStartDate,
  setEndDate,
  Graph_data,
  timeFormat,
  setTimeFormat,
}) => {
  // if (selectedDates && selectedDates.length === 2) {
  //   const startDate =
  //     selectedDates[0] instanceof Date
  //       ? selectedDates[0].toISOString().split("T")[0]
  //       : new Date(selectedDates[0]).toISOString().split("T")[0];

  //   const endDate =
  //     selectedDates[1] instanceof Date
  //       ? selectedDates[1].toISOString().split("T")[0]
  //       : new Date(selectedDates[1]).toISOString().split("T")[0];
  //   setStartDate(startDate);
  //   setEndDate(endDate);
  // }
if (selectedDates && selectedDates.length === 2) {
  const startDate = dayjs(selectedDates[0]).format("YYYY-MM-DD");
  const endDate = dayjs(selectedDates[1]).format("YYYY-MM-DD");
  setStartDate(startDate);
  setEndDate(endDate);
}
  // Handlers
  const handleDateChange = (dates) => setSelectedDates(dates);
  const handleChartChange = (value) => setSelectedChart(value);

  const handleParameterChange = (values) => {
    setSelectedParameters(values);
  };

  return (
    <div style={{ width: "100%" }}>
      <Row gutter={[16, 16]}>
        {/* Date Range */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Date Range</h4>
          <RangePicker
            presets={dateRanges}
            onChange={handleDateChange}
            // value={
            //   selectedDates && selectedDates.length
            //     ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
            //     : setSelectedDates([dayjs().subtract(2, "day"), dayjs()])
            // }
            value={
            selectedDates && selectedDates.length
              ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
              : []
          }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </Col>

        {/* Parameters */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Orb Fields</h4>
          <Select
            mode="multiple"
            allowClear
            showSearch
            placeholder="Select Orb Fields"
            maxTagCount={1}
            onChange={handleParameterChange}
            value={selectedParameters}
            style={{ width: "100%" }}
          >
            {chartFields.map((chart) => (
              <Option key={chart.value} value={chart.value}>
                {chart.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Chart Type */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <h4>Select Chart Type</h4>
          <Select
            showSearch
            placeholder="Select a chart type"
            onChange={handleChartChange}
            value={selectedChart || undefined}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {chartOptions.map((chart) => (
              <Option key={chart.value} value={chart.value}>
                {chart.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Time Format */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Typography variant="body2">Time Format</Typography>
          <Select
            value={timeFormat}
            style={{ width: "100%" }}
            onChange={setTimeFormat}
            options={[
              { label: "daily", value: "daily" },
              { label: "Weekly", value: "weekly" },
              { label: "Monthly", value: "monthly" },
            ]}
          />
        </Col>

        {/* Button */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button
            type="primary"
            block
            style={{
              backgroundColor: "#E11236",
              fontWeight: 900,
            }}
            onClick={Graph_data}
          >
            Generate Graph
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Orbdatetypefiledsselector;
